// Why a domain is not running, and what to tell the merchant about it.
//
// `domain.running === false` used to be a single undifferentiated state, and the
// dashboard answered all of it with "reach out to support@releva.ai to re-enable
// it". That is the wrong advice - and the only advice they got - for the one
// cause a merchant can fix themselves: they removed the app from their store.
// magellan-api records that cause in `runningSuspendedReason` (see the
// `POST /api/v0/partners/domains/uninstall` endpoint the Shopify connector calls
// from Shopify's `app/uninstalled` webhook).
export const APP_UNINSTALLED = 'appUninstalled';

// True only for a positively-recorded uninstall. A paused domain with no reason
// on it - every pause that predates the column, and every one a human made by
// hand - is NOT an uninstall and must keep the generic copy: `null` means "we
// did not record why", never "the app is still installed".
export const isAppUninstalled = (domain) =>
  domain?.running === false && domain?.runningSuspendedReason === APP_UNINSTALLED;

// Where a merchant goes to put the app back. The listing rather than a
// store-scoped install link: an uninstalled app has no OAuth grant left to
// resume, so reinstalling starts from the App Store like a first install does.
export const SHOPIFY_APP_STORE_URL = 'https://apps.shopify.com/releva-ai';
